<template>
    <div class="message-display">
      <div class="message-content">
        <p>{{ message }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'MessageDisplay',
    props: {
      message: String
    }
  }
  </script>
  
  <style scoped>
  .message-display {
    width: 100%;
  }
  .message-content {
    font-size: 1.1rem;
    line-height: 1.6;
  }
  </style>